<template>
    <div>
        <carousel v-if="arrDashboard.length > 0"
                  :responsive="configCarousel.responsive"
                  :margin="10"
                  :lazyLoad="true"
                  :loop="true"
                  :autoplay="true"
                  :nav="false">
            <div v-for="(v,k) in arrDashboard" :key="k" @click="clickDashboard(v)" class="dashboard-slider">
                <img :src="v.imageUrl" class="img-fluid img-dashboard-slider"/>
            </div>
        </carousel>
    </div>
</template>
<script>
import Vue from 'vue';
import Carousel from 'vue-owl-carousel'; // https://github.com/s950329/vue-owl-carousel
//helper
import Account from '@/helper/AccountHelper.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
import BzbsDashboard from '@/core/Campaign/service/BzbsDashboard.js';
//mixin
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//dashboard
import { DashboardConfigBuilder } from "@/core/Campaign/model/DashboardConfigModel.js";

/**
 * @property {string} apiConfig (require) Dashboard config_list
 */
export default {
    name: "DashboardSlider",
    mixins: [ErrorApiMixin],
    components: {
        Carousel,
    },
    props: {
        listName: String,
        apiConfig: String,
        controller: Object
    },
    data: function() {
        return {
            arrDashboard: [],
            configCarousel: {
                responsive: {
                    0: { items: 1 },
                },
            },
            trackingService: new TrackingService(this),
            trackingCate: 'privilagelist_page'
        };
    },
    created: function() {
        this.getDashboard();
        //error
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.controller.alertModal);
    },
    methods: {
        getDashboard: function() {
            var configBuilder = new DashboardConfigBuilder();
            configBuilder
            .setAppId(Vue.bzbsConfig.client_id)
            .setLocale(this.localeCode);

            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetDashboard(params, this.apiConfig).then((data) => {
                if (data.length > 0){
                    this.arrDashboard = data;
                }
                // else {
                //     // mock data
                //     var FullImageUrl = 'https://devstoragebuzzebees.blob.core.windows.net/dashboard/2e2e478e-08ca-470b-a4a9-46c5caef13af';
                //     this.arrDashboard.push({imageUrl:FullImageUrl},{imageUrl:FullImageUrl},{imageUrl:FullImageUrl},{imageUrl:FullImageUrl},{imageUrl:FullImageUrl});
                // }

                this.$emit('apiLoaded', {type: this.listName});
            }).catch(err => {
                this.errorResponse(err, this.errorHandler);
                this.$emit('apiLoaded', {type: this.listName});
            });
        },
        clickDashboard: function(dashboard) {
            if (dashboard.type == 'link') {
                if(dashboard.url){
                    if(dashboard.url.indexOf('/surprisebox') >= 0){
                        this.$router.push('/surprisebox');
                    }else if(dashboard.url.indexOf('product/category') > -1 || dashboard.url.indexOf('privilege/category') > -1 || dashboard.url.indexOf('marketplace/category') > -1){
                        let page = new URL(dashboard.url).pathname.split('/');
                        if(page.length > 1){
                            Account.setCacheCustom('category', {'id': page[3]});
                        }
                        window.location.replace(`/${page[1]}`);
                    }
                    else{
                        window.open(dashboard.url, '_blank');
                    }
                }
            } else if (dashboard.type == 'campaign') {
                this.$router.push('/privilege/' + dashboard.id);
            }
            this.trackingService.event(this.trackingCate, 'click_dashboard_list_main', null, null);
        },
    },
}
</script>
<style lang="scss">

</style>
